<template>
  <div class="service-management">
    <div class="header">
      <h2>服务商品管理</h2>
      <div class="header-ops">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item>
            <el-select v-model="searchForm.category" placeholder="筛选分类" clearable filterable allow-create default-first-option @change="handleSearch"
              style="width: 120px;">
              <el-option v-for="cat in categoryOptions" :key="cat" :label="cat" :value="cat"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.keyword" placeholder="搜索服务名称" clearable @clear="handleSearch"
              @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="showAddDialog">添加服务商品</el-button>
      </div>
    </div>

    <el-table :data="tableData" v-loading="loading">
      <el-table-column prop="product.id" label="ID" width="80"></el-table-column>
      <el-table-column label="商品图片" width="120">
        <template slot-scope="scope">
          <el-image 
            v-if="scope.row.product.coverImage"
            style="width: 80px; height: 50px; border-radius: 4px;"
            :src="$http.getFullImageUrl(scope.row.product.coverImage)"
            fit="cover"
            :preview-src-list="[$http.getFullImageUrl(scope.row.product.coverImage)]">
          </el-image>
          <span v-else style="color: #999; font-size: 12px;">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column label="所属企业" width="200">
        <template slot-scope="scope">
          {{ scope.row.enterprise ? scope.row.enterprise.name : '未关联' }}
        </template>
      </el-table-column>
      <el-table-column prop="product.name" label="服务名称" width="200"></el-table-column>
      <el-table-column prop="product.category" label="分类" width="120"></el-table-column>
      <el-table-column label="价格" width="120">
        <template slot-scope="scope">
          ¥{{ scope.row.product.price }}/{{ scope.row.product.priceUnit }}
        </template>
      </el-table-column>
      <el-table-column prop="product.sortOrder" label="排序" width="80"></el-table-column>
      <el-table-column label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.product.status === '上架' ? 'success' : 'info'">
            {{ scope.row.product.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="small" @click="editService(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="deleteService(scope.row.product.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      width="60%">
      <el-form :model="form" :rules="rules" ref="serviceForm" label-width="120px">
        <el-form-item label="所属企业" prop="enterpriseId">
          <el-select v-model="form.enterpriseId" placeholder="输入关键词搜索企业" style="width: 100%" filterable remote :remote-method="remoteSearchEnterprise" :loading="enterpriseLoading">
            <el-option 
              v-for="enterprise in enterprises" 
              :key="enterprise.id" 
              :label="enterprise.name" 
              :value="enterprise.id">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="服务名称" prop="name">
          <el-input v-model="form.name" placeholder="如：火箭发射服务、机器人定制"></el-input>
        </el-form-item>
        
        <el-form-item label="分类" prop="category">
          <el-select v-model="form.category" placeholder="请选择或输入分类" filterable allow-create default-first-option style="width: 100%">
            <el-option v-for="cat in categoryOptions" :key="cat" :label="cat" :value="cat"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" :rows="4" v-model="form.description"></el-input>
        </el-form-item>
        
        <el-form-item label="价格" prop="price">
          <el-input-number v-model="form.price" :min="0" :precision="2"></el-input-number>
        </el-form-item>
        
        <el-form-item label="价格单位" prop="priceUnit">
          <el-select v-model="form.priceUnit" placeholder="请选择或输入单位" filterable allow-create default-first-option>
            <el-option v-for="unit in priceUnitOptions" :key="unit" :label="unit" :value="unit"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品图片" prop="coverImage">
          <el-upload
            class="avatar-uploader"
            :action="uploadConfig.action"
            :headers="uploadConfig.headers"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeImageUpload">
            <div v-if="form.coverImage" class="avatar-preview">
              <img :src="$http.getFullImageUrl(form.coverImage)" class="avatar">
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">建议尺寸：800x600像素，支持jpg、png格式，大小不超过5MB</div>
        </el-form-item>
        
        <el-form-item label="联系方式">
          <el-input v-model="form.contactInfo" placeholder="电话、邮箱等"></el-input>
        </el-form-item>
        
        <el-form-item label="合作方式">
          <el-input v-model="form.cooperationMode" placeholder="如：定制开发、批量采购、长期合作等"></el-input>
        </el-form-item>
        
        <el-form-item label="服务特点">
          <el-tag
            v-for="(feature, index) in features"
            :key="index"
            closable
            @close="removeFeature(index)"
            style="margin-right: 10px; margin-bottom: 10px;">
            {{ feature }}
          </el-tag>
          <el-input
            v-if="featureInputVisible"
            v-model="featureInput"
            ref="featureInput"
            size="small"
            style="width: 200px;"
            @keyup.enter.native="addFeature"
            @blur="addFeature">
          </el-input>
          <el-button v-else size="small" @click="showFeatureInput">+ 添加特点</el-button>
        </el-form-item>
        
        <el-form-item label="排序" prop="sortOrder">
          <el-input-number v-model="form.sortOrder" :min="0"></el-input-number>
        </el-form-item>
        
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="上架">上架</el-radio>
            <el-radio label="下架">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitting">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api/config';

export default {
  name: 'ServiceManagement',
  data() {
    return {
      services: [],
      enterprises: [],
      enterpriseLoading: false,
      categoryOptions: ['工商服务', '税务服务', '制造业', '咨询服务', '科技服务', '其他'],
      priceUnitOptions: ['次', '月', '年', '项目', '台', '个'],
      tableData: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '添加服务商品',
      isEdit: false,
      submitting: false,
      searchForm: {
        keyword: '',
        category: ''
      },
      form: {
        id: null,
        enterpriseId: null,
        name: '',
        category: '',
        description: '',
        price: 0,
        priceUnit: '次',
        contactInfo: '',
        cooperationMode: '',
        coverImage: '',
        sortOrder: 0,
        status: '上架'
      },
      features: [],
      featureInputVisible: false,
      featureInput: '',
      rules: {
        enterpriseId: [{ required: true, message: '请选择企业', trigger: 'change' }],
        name: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        description: [{ required: true, message: '请输入描述', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        priceUnit: [{ required: true, message: '请选择单位', trigger: 'change' }]
      }
    };
  },
  computed: {
    uploadConfig() {
      return this.$http.getUploadConfig();
    }
  },
  mounted() {
    this.loadServices();
  },
  methods: {
    async loadServices() {
      try {
        this.loading = true;
        const params = {
          keyword: this.searchForm.keyword,
          category: this.searchForm.category
        };
        const response = await api.get('/services/admin/all', { params });
        this.tableData = response.data || [];
        // 动态提取分类和价格单位，与默认选项合并
        const defaultCategories = ['工商服务', '税务服务', '制造业', '咨询服务', '科技服务', '其他'];
        const existingCategories = this.tableData.map(item => item.product.category).filter(Boolean);
        this.categoryOptions = [...new Set([...defaultCategories, ...existingCategories])];
        
        const defaultUnits = ['次', '月', '年', '项目', '台', '个'];
        const existingUnits = this.tableData.map(item => item.product.priceUnit).filter(Boolean);
        this.priceUnitOptions = [...new Set([...defaultUnits, ...existingUnits])];
      } catch (error) {
        this.$message.error('加载服务商品失败');
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.loadServices();
    },
    async remoteSearchEnterprise(query) {
      if (query !== undefined && query !== '') {
        this.enterpriseLoading = true;
        try {
          const response = await api.get('/enterprises/search', { params: { keyword: query } });
          this.enterprises = response.data || [];
        } catch (error) {
          console.error('搜索企业失败:', error);
        } finally {
          this.enterpriseLoading = false;
        }
      } else {
        // 初始加载：加载前50个企业供选择
        this.enterpriseLoading = true;
        try {
          const response = await api.get('/enterprises/search');
          this.enterprises = response.data || [];
        } catch (error) {
          console.error('加载企业列表失败:', error);
        } finally {
          this.enterpriseLoading = false;
        }
      }
    },
    showAddDialog() {
      this.dialogTitle = '添加服务商品';
      this.isEdit = false;
      this.resetForm();
      this.remoteSearchEnterprise();
      this.dialogVisible = true;
    },
    editService(item) {
      this.dialogTitle = '编辑服务商品';
      this.isEdit = true;
      this.form = { ...item.product };
      
      // 解析特点
      try {
        this.features = item.product.features ? JSON.parse(item.product.features) : [];
      } catch {
        this.features = [];
      }

      this.remoteSearchEnterprise();
      this.dialogVisible = true;
    },
    async deleteService(id) {
      try {
        await this.$confirm('确定要删除这个服务商品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        await api.delete(`/services/admin/${id}`);
        this.$message.success('删除成功');
        this.loadServices();
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败');
        }
      }
    },
    submitForm() {
      this.$refs.serviceForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        
        try {
          this.submitting = true;
          
          // 将特点转为JSON
          const data = {
            ...this.form,
            features: JSON.stringify(this.features)
          };
          
          if (this.isEdit) {
            await api.put(`/services/admin/${data.id}`, data);
            this.$message.success('更新成功');
          } else {
            await api.post('/services/admin', data);
            this.$message.success('添加成功');
          }
          
          this.dialogVisible = false;
          this.loadServices();
        } catch (error) {
          this.$message.error(this.isEdit ? '更新失败' : '添加失败');
        } finally {
          this.submitting = false;
        }
      });
    },
    resetForm() {
      this.form = {
        id: null,
        enterpriseId: null,
        name: '',
        category: '',
        description: '',
        price: 0,
        priceUnit: '次',
        contactInfo: '',
        cooperationMode: '',
        coverImage: '',
        sortOrder: 0,
        status: '上架'
      };
      this.features = [];
      if (this.$refs.serviceForm) {
        this.$refs.serviceForm.resetFields();
      }
    },
    showFeatureInput() {
      this.featureInputVisible = true;
      this.$nextTick(() => {
        this.$refs.featureInput.$refs.input.focus();
      });
    },
    addFeature() {
      if (this.featureInput) {
        this.features.push(this.featureInput);
        this.featureInput = '';
      }
      this.featureInputVisible = false;
    },
    removeFeature(index) {
      this.features.splice(index, 1);
    },
    handleUploadSuccess(response) {
      if (response.success && response.data) {
        this.form.coverImage = response.data.fileUrl;
        this.$message.success('图片上传成功');
      } else {
        this.$message.error('图片上传失败: ' + (response.message || '未知错误'));
      }
    },
    beforeImageUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isImage) {
        this.$message.error('商品图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('商品图片大小不能超过 5MB!');
      }
      return isImage && isLt5M;
    }
  }
};
</script>

<style scoped lang="scss">
.service-management {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    h2 {
      margin: 0;
    }

    .header-ops {
      display: flex;
      align-items: center;
      gap: 15px;

      .search-form {
        margin-bottom: 0;

        .el-form-item {
          margin-bottom: 0;
        }
      }
    }
  }
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: inline-block;

  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 200px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: border-color 0.3s;

    &:hover {
      border-color: #409EFF;
    }
  }
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}

.avatar-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  line-height: 1.4;
}
</style>
